import React from 'react';
import ClayBackground from './ClayBackground';

const About = ({ data }) => {
    return (
        <ClayBackground className="py-20" opacity={0.3}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="lg:flex lg:items-stretch lg:gap-16">
                    {/* Image - matching height */}
                    <div className="lg:w-1/2 mb-12 lg:mb-0 flex">
                        <div className="relative flex-1">
                            <div className="w-full h-full min-h-[500px] lg:min-h-[600px] bg-gradient-to-br from-stone-100 to-stone-200 rounded-2xl overflow-hidden shadow-lg">
                                {data.image ? (
                                    <img
                                        src={data.image}
                                        alt="About section"
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center">
                                        <div className="text-center">
                                            <div className="w-20 h-20 mx-auto mb-4 bg-stone-300 rounded-full flex items-center justify-center">
                                                <svg className="w-10 h-10 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                                </svg>
                                            </div>
                                            <p className="text-sm text-stone-600">Upload an image in the admin panel</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Content with matching height*/}
                    <div className="lg:w-1/2 flex">
                        <div className="flex-1 bg-white/70 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-stone-200/50 flex flex-col justify-center min-h-[500px] lg:min-h-[600px]">
                            <div className="space-y-6">
                                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-stone-800 mb-8 leading-tight" style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' }}>
                                    {data.title}
                                </h2>

                                <p className="text-lg text-stone-700 leading-relaxed" style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.05)' }}>
                                    {data.content}
                                </p>

                                <p className="text-lg text-stone-700 leading-relaxed" style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.05)' }}>
                                    My approach combines evidence-based therapeutic techniques with genuine empathy and understanding.
                                    I believe that every person has the capacity for growth and healing when provided with the right support
                                    and tools.
                                </p>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8">
                                    <div className="bg-white/85 backdrop-blur-sm p-6 rounded-xl shadow-md border border-stone-200/50">
                                        <div className="w-12 h-12 bg-amber-200 rounded-lg flex items-center justify-center mb-4">
                                            <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <h3 className="font-semibold text-stone-800 mb-2">Licensed Professional</h3>
                                        <p className="text-stone-600 text-sm">Fully licensed and certified with ongoing education</p>
                                    </div>

                                    <div className="bg-white/85 backdrop-blur-sm p-6 rounded-xl shadow-md border border-stone-200/50">
                                        <div className="w-12 h-12 bg-stone-200 rounded-lg flex items-center justify-center mb-4">
                                            <svg className="w-6 h-6 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                            </svg>
                                        </div>
                                        <h3 className="font-semibold text-stone-800 mb-2">Compassionate Care</h3>
                                        <p className="text-stone-600 text-sm">Providing a safe, judgment-free environment</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ClayBackground>
    );
};

export default About;